import * as React from "react";

export const IconFilterList = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M10.5 18H14.5V16H10.5V18ZM3.5 6V8H21.5V6H3.5ZM6.5 13H18.5V11H6.5V13Z" fill="currentColor" />
    </svg>
  );
};
